import React from "react";

export default function DeteteAccount() {
  return (
    <div className="w-full min-h-[70vh]">
      <div className="w-full bg-white sm:max-w-screen-2xl h-1/2 sm:px-6 mx-auto flex flex-wrap justify-between">
        <div className="w-full h-[35vh] bg-[#fccd5d] my-12 flex items-center justify-center text-[#484848] font-bold">
          <p className="text-inherit transition duration-1000 relative text-6xl after:inline-block after:absolute after:ease-in-out after:bg-[#484848] after:h-6 after:w-1/4 after:left-0 after:right-0 after:m-auto after:-bottom-14 after:transition-all after:duration-1000 hover:after:w-full">
            {" "}
            Suppression de compte
          </p>
        </div>
        <div className="terms">
          <div class="mt-4">
            <h2>Connexion à l'Application :</h2>
            <p>
              Lancez l'application sur votre appareil mobile ou ouvrez-la dans
              votre navigateur web. <br />
              Entrez vos identifiants de connexion (nom d'utilisateur et mot de
              passe) dans les champs appropriés. <br />
              Cliquez sur le bouton de connexion pour accéder à votre compte.
            </p>
          </div>

          <div class="mt-4">
            <h2>Accès à la Section Mon Profil :</h2>
            <p>
              Une fois connecté(e), recherchez et sélectionnez l'option "Mon
              Profil" ou "Mon Compte" dans le menu principal de l'application.{" "}
              <br />
              Cette option peut être représentée par une icône de profil ou par
              votre nom d'utilisateur. <br />
              Navigation vers la Page de Gestion de Compte : <br />
              Sur la page Mon Profil, recherchez le bouton “Supprimer mon
              compte”
            </p>
          </div>

          <div class="mt-4">
            <h2>Initiation de la Suppression du Compte :</h2>
            <p>
              Avant de procéder, veuillez lire attentivement les informations et
              les avertissements associés à la suppression du compte.
              Assurez-vous de comprendre les conséquences.
            </p>
          </div>
          <div class="mt-4">
            <h2>Confirmation de la Suppression :</h2>
            <p>
              Lorsque vous choisissez de supprimer votre compte, le système peut
              vous demander de confirmer votre décision.
            </p>
            <p>
              Pour des raisons de sécurité, il peut vous être demandé de saisir
              à nouveau votre mot de passe ou de répondre à une question de
              sécurité.
            </p>
          </div>
          <div class="mt-4">
            <h2>Archivage du Compte Utilisateur :</h2>
            <p>
              Une fois que vous avez confirmé la suppression, votre compte
              utilisateur sera archivé.
            </p>
            <p>
              Toutes les informations personnelles et les données associées à
              votre compte seront supprimées de manière sécurisée de nos
              serveurs.
            </p>
            <p>
              Veuillez noter que cette action est irréversible et que vous ne
              pourrez pas récupérer votre compte une fois qu'il aura été
              supprimé.
            </p>
          </div>
          <div class="mt-4">
            <h2>Confirmation de la Suppression Réussie :</h2>
            <p>
              Une fois la suppression terminée, vous recevrez une confirmation
              sur l'application ou par e-mail, indiquant que votre compte a été
              supprimé avec succès.
            </p>

            <p>
              À partir de ce moment, vous ne pourrez plus accéder à votre compte
              ni à ses fonctionnalités associées.
            </p>
            <p>
              Nous vous recommandons de prendre en compte les éléments suivants
              avant de supprimer votre compte :
            </p>
            <p>
              Assurez-vous de sauvegarder toutes les données ou informations
              importantes associées à votre compte avant de le supprimer, car
              celles-ci seront définitivement perdues.
            </p>
            <p>
              Si vous envisagez de réutiliser notre application à l'avenir,
              sachez que vous devrez créer un nouveau compte à partir de zéro.
            </p>
            <p>
              Si vous rencontrez des difficultés ou si vous avez des questions
              concernant la suppression de votre compte, n'hésitez pas à
              contacter notre équipe d'assistance technique pour obtenir de
              l'aide supplémentaire.
            </p>
            <p>
              Nous vous remercions pour votre utilisation de notre application
              et nous espérons vous revoir bientôt.
            </p>

            <p>Cordialement,</p>

            <p>Eagri </p>
          </div>
        </div>
      </div>
    </div>
  );
}
